<template>

  <div style=" height:100vh; margin-bottom:70px;">
<!-- DESKTOP -->
<v-container class="ma-0 pa-0 hidden-sm-and-down upContainerDesktop "  fluid>
   <div class="mainImg-overlay1 hide-ie" style="  position:absolute;">                 
</div>
<div class="mainImg-overlay1 show-ie" style="  ">                 
</div>
<span v-if="user.picture">
  <div class="divForProfileBlurImg hide-ie"  style="">
    <img v-if="user.picture.url" class=" profileBlurImg" :src="user.picture.url" style="width:100%; position:relative">
     <img v-else  class=" profileBlurImg" :src="user.picture" style="width:100%; position:relative">
 
  </div>

  <div class="divForProfileBlurImg show-ie"  style="position:absolute;">
   
  </div>
  </span>
<span v-else>
  <div  class="divForProfileBlurImg">
      <img class=" profileBlurImg" style="width:100%; position:relative"  src="../../../assets/user-icon.png" alt="" >
  </div>
</span>
</v-container>

<!-- MOBILE -->
<v-container class="ma-0 pa-0 hidden-md-and-up upContainerMobile"  fluid>
   <div class="mainImg-overlay1" style="  position:absolute;">                 
</div>
<span v-if="user.picture">
  <div  class="divForProfileBlurImg">
    <img v-if="user.picture.url" class=" profileBlurImg" :src="user.picture.url" style="width:100%; position:relative">
     <img v-else  class=" profileBlurImg" :src="user.picture" style="width:100%; position:relative">
  </div>
</span>
<span v-else>
  <div  class="divForProfileBlurImg">
      <img class=" profileBlurImg" style="width:100%; position:relative"  src="../../../assets/user-icon.png" alt="" >
  </div>
</span>
</v-container>



<v-layout justify-center>
  
  <v-flex xs12 md10 >

<!-- DESKTOP -->
      <v-layout justify-center row wrap class="profileBlurRow1 hidden-sm-and-down" style="bottom:30px;">

          <v-flex
            xs5
            
            
            
          >
            <!-- <v-avatar v-if="user.picture"
          
              size="10"
              class="grey avatar2 lighten-4"
            >
      
            <img v-if="user.picture[0].url"  alt="avatar" class="avatarImg" :src="user.picture[0].url">
            <img v-else   alt="avatar" class="avatarImg" :src="user.picture" >
            </v-avatar>
            <v-avatar v-else 
                
              class=" avatar2 lighten-4">
                  <img src="../../../assets/user-icon.png" alt="" class="avatarImg1">
                </v-avatar>
            -->


          <v-list style="background:transparent" >
            <v-list-tile avatar style="background:transparent"   >
                            <v-list-tile-avatar v-if=" user.picture">
                              <img v-if="user.picture.url" :src="user.picture.url + '_profile'" >
                              <img v-else :src="user.picture" >
                            </v-list-tile-avatar>
                            <v-list-tile-avatar v-else >
                              <img src="../../../assets/user-icon.png" alt="" class="avatarImg1">
                            </v-list-tile-avatar>
                            <v-list-tile-content dark >
                              <v-list-tile-title style="color:white" v-html="user.displayName"></v-list-tile-title>
                              <v-list-tile-sub-title style="color:white" v-if="user.email"> {{user.email}} </v-list-tile-sub-title>
                              <v-list-tile-sub-title style="color:white" v-else> {{gLang[lang].myAccount.connectedWith}} {{provider(user)}}</v-list-tile-sub-title>
                              <v-list-tile-sub-title style="color:white"> Role: {{user.role}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
          </v-list>


          </v-flex>
             
          <!-- <v-flex class="addTabletPadding pl-3 pt-4" style="text-align:left;" > 
               <h4 style="color:white" class="ma-0" >{{user.displayName}}</h4>
              <p v-if="user.email" style="color:white">{{user.email}}</p>
              <p v-else style="color:white"   v-html=" '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + provider(user) + '</span>' "></p>
          </v-flex> -->
 <v-spacer></v-spacer>
          <v-flex xs1 style="position:relative">
            <v-btn v-if="user.email" fab dark @click="dialog = true" style=" position:relative; right:0px; ">
              <v-icon>
                edit
              </v-icon>
            </v-btn>

             <!-- <v-dialog v-model="dialog" persistent max-width="500px" > 
               v-if="user.email"
      <v-btn  fab dark slot="activator"><v-icon>edit</v-icon></v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Profile</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
             <v-form style="    width: 94%;">

                      <v-text-field
              name="input-1"
              label="Username"
              :v-model="user.displayName"
              id="testing"
              :rules="[() => user.displayName.length > 0 || 'This field is required.']"
              required
            ></v-text-field>

                <v-text-field v-if="user.email"
                class=""
                  label="E-mail"
                  :v-model="user.email"
                  :rules="[() => user.email.length > 0 || 'This field is required.']"
                  required
                ></v-text-field>

                      <v-text-field
              name="input-10-1"
              label="Password"

              v-model="password"
              min="8"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              counter
              :rules="[() => password.length > 0 || 'This field is required.']"
              required
            ></v-text-field>
            
            <v-layout row justify-center>
                   <v-btn style="width:215px;"
                                        color="primary"
                                        class="white--text"
                                        @click="clickInputMain()"
                                        >Profile Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
            </v-layout>
            
            
            
                  </v-form>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click.native="dialog = false">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

  <web-change-info  :dialog="dialog" :user="user" @clicked="dialog = !dialog"></web-change-info>


          </v-flex>
        </v-layout>


<!-- MOBILE -->
        <v-layout justify-center row wrap class="profileBlurRow2 hidden-md-and-up pb-3 pl-3 pr-5" style="bottom:10px;">

          <v-flex
            xs10
            
            
            
          >
            <!-- <v-avatar v-if="user.picture"
          
              size="10"
              class="grey avatar2 lighten-4"
            >
      
            <img v-if="user.picture[0].url"  alt="avatar" class="avatarImg" :src="user.picture[0].url">
            <img v-else   alt="avatar" class="avatarImg" :src="user.picture" >
            </v-avatar>
            <v-avatar v-else 
                
              class=" avatar2 lighten-4">
                  <img src="../../../assets/user-icon.png" alt="" class="avatarImg1">
                </v-avatar>
            -->


          <v-list style="background:transparent" >
            <v-list-tile avatar style="background:transparent"   >
                            <v-list-tile-avatar v-if=" user.picture ">
                              <img v-if="user.picture.url" :src="user.picture.url + '_profile'" >
                              <img v-else :src="user.picture" >
                            </v-list-tile-avatar>
                            <v-list-tile-avatar v-else >
                              <img src="../../../assets/user-icon.png" alt="" class="avatarImg1">
                            </v-list-tile-avatar>
                            <v-list-tile-content dark >
                              <v-list-tile-title style="color:white" v-html="user.displayName"></v-list-tile-title>
                              <v-list-tile-sub-title style="color:white" v-if="user.email"> {{user.email}} </v-list-tile-sub-title>
                              <v-list-tile-sub-title style="color:white" v-else> {{gLang[lang].myAccount.connectedWith}} {{provider(user)}}</v-list-tile-sub-title>
                              <v-list-tile-sub-title style="color:white"> Role: {{user.role}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
          </v-list>


          </v-flex>
 <v-spacer></v-spacer>
 
          <v-flex xs1 style="position:relative" >
            
            <v-btn v-if="user.email" fab small dark @click="dialog = true" style=" position:relative;  opacity: 1" >
              <v-icon>
                edit
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>











<!-- COMMON -->



      <v-tabs fixed centered style="margin-bottom:70px;" >
    <v-tabs-bar class="black" dark style="height:6vh">
      <v-tabs-slider class="primary" ></v-tabs-slider>
      
      <v-tabs-item class="paddingForTabs " href="#tab-1"  
        
      > <p class="paddingForTabs ma-0" style="color:white"> {{gLang[lang].myAccount.myArtefacts}}</p>
        
      </v-tabs-item>
      <v-tabs-item class="paddingForTabs " href="#tab-2" style="color:white"  
        
      > <p class="paddingForTabs ma-0" style="color:white">{{gLang[lang].myAccount.favourites}} </p>
        
      </v-tabs-item>

    </v-tabs-bar>
    <v-tabs-items style="border:1px solid #efefef; background-color:#FAFAFA;">
      <v-tabs-content id='tab-1' >
    


  <v-container grid-list-md >

   

      <!-- <v-dialog style="background-color:white; padding:50px;" v-model="upgradeDialog">
          <v-select
          :items="items"
          v-model="select"
          label="Select"
          class="input-group--focused"
          item-value="text"
        ></v-select>
        </v-dialog>  -->



      
  <v-layout  row fluid wrap class="" v-if="artefactsAdded.length > 0">
    <v-flex xs12 sm12 md6 lg4  v-for="(artefact,i) in artefactsAdded" :key="i" v-if="artefact.userId==user._id" >
    <web-artefact-card :artefact='artefact' :showStatus="true"></web-artefact-card>
      </v-flex>
  </v-layout>
  <v-layout v-else justify-center style="backgroung-color:#FAFAFA" class="pt-4">
    <h4 class="text-xs-center" style="color:grey"><i>{{gLang[lang].myAccount.noAddedArtefacts}}</i> </h4>
  </v-layout>

  </v-container>
      </v-tabs-content>
    <v-tabs-content id='tab-2'>

      <div v-if=" artefacts.length > 0 || collections.length > 0 || groups.length > 0">
<v-toolbar-title class="body-2 grey--text mt-4 ml-4 text-md-center" style="" v-if="artefacts.length > 0"><h5 class="mt-3">{{gLang[lang].myAccount.favouriteArtefact}}</h5>  </v-toolbar-title>
      <v-layout justify-center row fluid wrap class="" v-if="artefacts.length > 0">
    <v-flex xs12 sm12 md6 lg4  v-for="(artefact,i) in artefacts" :key="i"  >
    <web-artefact-card :artefact='artefact'></web-artefact-card>
      </v-flex>
  </v-layout>


  <v-toolbar-title class="body-2 grey--text mt-4 ml-4 text-md-center" style="" v-if="collections.length > 0"><h5 class="mt-3">{{gLang[lang].myAccount.favouriteCollection}}</h5>  </v-toolbar-title>
      <v-layout justify-center row fluid wrap class="" v-if="collections.length > 0">
    <v-flex xs12 sm12 md6 lg4  v-for="(collection,i) in collections" :key="i"  >
     <web-collection-card :collection='collection' :artefacts='artefactsAll'></web-collection-card>
      </v-flex>
  </v-layout>


  <v-toolbar-title class="body-2 grey--text mt-4 ml-4 text-md-center" style="" v-if="groups.length > 0"><h5 class="mt-3">{{gLang[lang].myAccount.favouriteGroup}}</h5>  </v-toolbar-title>
      <v-layout justify-center row fluid wrap class="" v-if="groups.length > 0">
    <v-flex xs12 sm12 md6 lg4  v-for="(group,i) in groups" :key="i"  >
    <web-group-card :group='group' :collections='collectionsAll' class="pa-1" > </web-group-card>
      </v-flex>
  </v-layout>
  
      </div>

      <div v-else>
<v-layout  justify-center style="backgroung-color:#FAFAFA" class="pt-4">
    <h4 class="text-xs-center" style="color:grey"><i>{{gLang[lang].myAccount.noFavourites}}</i> </h4>
  </v-layout>
      </div>
      
      </v-tabs-content>
    </v-tabs-items>
  </v-tabs>
  </v-flex>
</v-layout>

    <web-speed-dial-add v-if="user.role == 'Contributor' || user.role == 'Moderator'"></web-speed-dial-add>

  </div>


</template>





<script>
import axios from "axios";
export default {
  data() {
    return {
      showFailAlreadyRequested:false,
      showFailRoleAlready:false,
      timeout: 6000,
      colorS: "info",
      colorF: "red",
      mode: true,
      showSucces: false,
      showFail: false,
      dialog: false,
      password: "",
      email: "",
      name: "",
      upgradeDialog: false,
      e1: true,
      fling: false,
      hover: false,
      tabs: null,
      // Timisoara:'Timisoara',
      //       testIssues : [
      // {
      //     img: "http://www.telegrafonline.ro/imagini/mari/61705369-1465412591.jpg", title: 'Groapa Strada Tapia', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://stiri.botosani.ro/media/images/articles/big/bancile-din-botosani-distractie-pentru-vandali-OK7nDf.jpg", title: 'Banca rupta in Parcul Rozelor', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://www.reporterntv.ro/imagini/2015/09/09/big/imagini-de-cosmar-intr-o-scoala-din-constanta-copii-asteptati-in-clasa-i-cu-banci-si-scaune-rupte-128426.jpg", title: 'Conditii primitive la Politehnica', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://www.reporterntv.ro/imagini/2015/09/09/big/imagini-de-cosmar-intr-o-scoala-din-constanta-copii-asteptati-in-clasa-i-cu-banci-si-scaune-rupte-128426.jpg", title: 'Conditii primitive la Politehnica', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://stiri.botosani.ro/media/images/articles/big/bancile-din-botosani-distractie-pentru-vandali-OK7nDf.jpg", title: 'Banca rupta in Parcul Rozelor', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://www.telegrafonline.ro/imagini/mari/61705369-1465412591.jpg", title: 'Groapa Strada Tapia', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      //    ],
      items: ["Added Artefacts", "My Issues"]
      // text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      // days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      // months:[ "Jan", "Feb", "Mar", "Apr",
      // 	    "May", "Jun", "July", "Aug",
      //     "Sep", "Oct", "Nov", "Dec"]
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    artefacts() {
      return this.$store.getters.loadFavoriteArtefacts(this.user._id);
    },
    collections() {
      return this.$store.getters.loadFavoriteCollections(this.user._id);
    },
    groups() {
      return this.$store.getters.loadFavoriteGroups(this.user._id);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    artefactsAll() {
      return this.$store.getters.loadArtefacts;
    },
    collectionsAll() {
      return this.$store.getters.loadAllCollections;
    },

    artefactsAdded() {
      return this.$store.getters.loadAddedArtefacts(this.user._id);
    }
  },
  methods: {
    sendMessage() {
      if(this.select == this.user.role)
      {
        this.showFailRoleAlready = true;
        this.upgradeDialog = false;
      }
      else{
      axios
        .post("/api/requests", { user: this.user, role: this.select })
        .then(response => {
          this.showSucces = true;
          this.upgradeDialog = false;
        })
        .catch(err => {
          if(err.response.status == 409)
          {this.showFailAlreadyRequested = true;
          this.upgradeDialog = false;}
          else{
          this.showFail = true;
          this.upgradeDialog = false;
          }
        });

      }

      // var concatMessage =
      //   this.user.displayName +
      //   " requests rights for the role: \n" +
      //   this.select +
      //   " \n";
      // axios
      //   .post("/api/messages/email", {
      //     message: concatMessage,
      //     email: "hera.restore@gmail.com"
      //   })
      //   .then(response => {
      // this.showSucces = true;
      // this.upgradeDialog = false;
      //   })
      //   .catch(err => {
      // this.showFail = true;
      // this.upgradeDialog = false;
      //   });
    },
    provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";
      else if (user.hasOwnProperty("google")) return "Google";
      else if (user.hasOwnProperty("live")) return "Microsoft Live";
      else return "Local Register";
    },
    clickInputMain() {
      this.$refs.fileInput1.click();
    }
    //    createYears() {
    //         var currentYear = 2010;
    //         var startYear = 1950;
    //         var yearss = [];
    //         while ( startYear <= currentYear ) {
    //           yearss.push(startYear++);
    //         }
    //         return yearss;
    // },
    // changeLocation()
    // {
    //   this.$store.dispatch('updateUser',this.user);
    // }
  },
  mounted() {
    document.title = "My Account";
    window.scrollTo(0, 0);
  },
  created() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
  }
};
</script>




<style scoped>
.show-ie {
  display: none;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .hide-ie {
    display: none;
  }
  .show-ie {
    display: block;
  }
}

/* .avatar {
  width: 80px;
  height: 80px;

  border: 12px solid white;
}

.avatar2 {
  width: 50px;
  height: 50px;
    background-color:white;
  border: 12px solid white;
}

.avatarImg {
  border: 1px solid white;
} */

.profileContainer {
  height: 48vh;
  /* background-image: url('https://cdn3.dualshockers.com/wp-content/uploads/2017/02/neytiri-avatar-5824.jpg'); */

  background: black; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    black,
    grey
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    black,
    grey
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    black,
    grey
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(to right, black, grey); /* Standard syntax */
  margin-right: 0px !important;
  width: 100%;
  max-width: 2500px;
}
.profileBlurImg {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-filter: blur(30px); /* Safari */
  filter: blur(30px);
  opacity: 0.6;
  filter: alpha(opacity=60);
}
.profileCard {
  overflow: hidden;
}
.profileBlurRow2 {
  height: 10vh;
  position: relative;
}
.profileTabInfo {
  height: 40vh;
}
.profileDialog {
  z-index: 999999;
}
.photoContainer {
  width: 100%;
}
.mainImg-overlay1 {
  background: black; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    black,
    grey
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    black,
    grey
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(right, black, grey);
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(to right, black, grey); /* Standard syntax */
  position: absolute;
  width: 100%;
  height: 48vh;
}

.divForProfileBlurImg {
  position: absolute;
  width: 100%;
  height: 48vh;
  position: absolute;
  overflow: hidden;
}
.profileBlurRow1 {
  height: 8vh;
  position: relative;
}
.upContainerDesktop {
  height: 34vh;
}
.upContainerMobile {
  height: 36vh;
}
.profileBlurRow2 {
  height: 8vh;
  position: relative;
}
@media screen and (max-width: 600px) {
  .upContainerMobile {
    height: 34vh;
  }
  .profileBlurRow2 {
    height: 10vh;
    position: relative;
  }
}
@media screen and (max-width: 1500px) {
  .profileBlurRow1 {
    height: 6vh;
    position: relative;
  }
  .mainImg-overlay1 {
    height: 48vh;
  }
  .divForProfileBlurImg {
    height: 48vh;
  }
  .upContainerDesktop {
    height: 36vh;
  }
}
/* @media screen and (max-width:950px) {
  .profileBlurRow1 { 
    height:8vh;
    position: relative;
  }

  .mainImg-overlay1 {
    height: 48vh;
  }

  .divForProfileBlurImg {
    height: 48vh;
  }

  .upContainerDesktop {
    height: 34vh;
  }

  .addTabletPadding {
    padding-left: 20px;
  }
} */
.mainImg-overlay2 {
  background: black; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    black,
    grey
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(right, black, grey);
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(right, black, grey);
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(to right, black, grey);
  /* Standard syntax */

  position: absolute;
  width: 100%;
  height: 27vh;
}
.paddingForTabs {
  /* padding-left: 50px;
  padding-right: 50px;
  width: 200px; */
}
.paddingForTabsmall {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Presentation/User/MyAccount.vue